// Which sidebar nav item should be highlighted for the current path.
//
// Lives in its own JSX-free module so it can be imported by Node's test runner
// (which strips TS types but cannot transform JSX, so importing Shell.tsx
// directly is not an option).

/**
 * The most specific nav target matching `pathname`, or null if none do.
 *
 * NavLink's own `isActive` matches by prefix, so at /cv/new BOTH 生成简历
 * (/cv/new) and 简历定制 (/cv) reported active — two items highlighted at once,
 * with no way to tell which page you were actually on. Adding `end` to every
 * NavLink would have swapped one bug for another: /apps, /interview and /offers
 * are all prefixes of real child routes (/apps/:id, /interview/:sessionId,
 * /offers/compare) and are *supposed* to stay lit there.
 *
 * Longest match wins, which gets both cases right without a per-item flag:
 * /cv/new picks /cv/new over /cv, while /apps/123 has only /apps to match.
 *
 * Paths are basename-stripped — BrowserRouter has basename="/app", so
 * useLocation() reports /cv/new rather than /app/cv/new.
 */
export function activeNavTarget(pathname: string, targets: string[]): string | null {
  let best: string | null = null;
  for (const t of targets) {
    // The trailing slash matters: without it "/cvs" would match target "/cv".
    if (pathname === t || pathname.startsWith(t.endsWith('/') ? t : t + '/')) {
      if (best === null || t.length > best.length) best = t;
    }
  }
  return best;
}
